/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Signup_LinkInputs */

const en_auth_login_signup_link = /** @type {(inputs: Auth_Login_Signup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create one, it's free`)
};

/**
* | output |
* | --- |
* | "Create one, it's free" |
*
* @param {Auth_Login_Signup_LinkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_signup_link = /** @type {((inputs?: Auth_Login_Signup_LinkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Signup_LinkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_login_signup_link(inputs)
});